import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/inquiry-my-signup',
    name: 'SignUp',
    component: () => import('@/views/SignUp.vue')
  },
  {
    path: '/inquiry-my-signup-form',
    name: 'SignUpForm',
    component: () => import('@/views/SignUpForm.vue')
  },
  {
    path: '/inquiry-my-signin',
    name: 'SignIn',
    component: () => import('@/views/SignIn.vue')
  },
  {
    path: '/inquiry-my-signout',
    name: 'SignOut',
    component: () => import('@/views/SignOut.vue')
  },
  {
    path: '/inquiry-auth-google',
    name: 'AuthGoogle',
    component: () => import('@/views/AuthGoogle.vue')
  },
  {
    path: '/inquiry-my-error-page',
    name: 'Error',
    component: () => import('@/views/Error.vue')
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: () => import('@/views/TermsOfService.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/architecture',
    name: 'Architecture',
    component: () => import('@/views/Architecture.vue')
  },
  {
    path: '/inquiry-page-builder',
    name: 'PublicPageBuilder',
    props: true,
    component: () => import('@/views/login/LoginPageBuilder.vue')
  },
  {
    path: '/inquiry-my-admin',
    name: 'LoginHome',
    component: () => import('@/views/login/LoginHome.vue'),
    children: [
      {
        path: '/inquiry-my-admin/dashboard',
        name: 'LoginDashboard',
        props: true,
        component: () => import('@/views/login/LoginDashboard.vue')
      },
      {
        path: '/inquiry-my-admin/whatsapp',
        name: 'LoginWhatsApp',
        props: true,
        component: () => import('@/views/login/LoginWhatsapp.vue')
      },
      {
        path: '/inquiry-my-admin/bio',
        name: 'LoginBioLinks',
        props: true,
        component: () => import('@/views/login/BioLinks.vue')
      },
      {
        path: '/inquiry-my-admin/shortener',
        name: 'LoginShortener',
        props: true,
        component: () => import('@/views/login/LoginShortener.vue')
      },
      {
        path: '/inquiry-my-admin/page-builder',
        name: 'LoginPageBuilder',
        props: true,
        component: () => import('@/views/login/LoginPageBuilder.vue')
      }
    ]
  },
  // 404 Catch-all route - must be last
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/Error.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for admin routes
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    // Get user from cookie or localStorage
    const userCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('inquiry-user='))

    if (userCookie) {
      try {
        const userData = JSON.parse(decodeURIComponent(userCookie.split('=')[1]))

        // Check if user has admin role
        if (userData?.merchant?.role === 'admin') {
          next()
        } else {
          // Not an admin, redirect to dashboard
          console.warn('Access denied: Admin role required')
          next({ name: 'LoginDashboard' })
        }
      } catch (error) {
        console.error('Error parsing user data:', error)
        next({ name: 'SignIn' })
      }
    } else {
      // No user logged in, redirect to sign in
      next({ name: 'SignIn' })
    }
  } else {
    next()
  }
})

export default router

